import axios from "./axios"

export const createCaseService = (data) => {
	return axios.post(`/case`, data)
}

export const getCaseListService = (data) => {
	return axios.get(`/case`)
}

export const uploadFileService = (data) => {
	return axios.post(`/case/upload`, data)
}

export const getUploadFileSummaryService = (data) => {
	return axios.post(`/case/upload/folder_preview`, data)
}

export const deletCaseService = (caseId) => {
	return axios.delete(`/case/${caseId}`, {
		params: { case_status: "Hard-delete" },
	})
}

export const extractFileService = (data) => {
	return axios.post(`/case/text_extract`, data)
}

export const kbMakingService = (data) => {
	return axios.post("/case/kbmaking", data)
}

export const PiiExtractService = (data) => {
	return axios.post("/case/pii_extract", data)
}

export const RevertPiiExtractService = (data) => {
	return axios.post("/case/revert_pii_extract", data)
}

export const RevertTextExtractService = (data) => {
	return axios.post("/case/revert_text_extract", data)
}

export const ChangeCaseModeService = (data) => {
	return axios.post(`/case/change_mode?case_id=${data.case_id}&case_mode=${data.case_mode}`)
}

export const getCaseDetails = (dataId) => {
	return axios.get(`/case/${dataId}`)
}

export const getExtractJobDetails = (data) => {
	const filter = {
		"jobs.file_status": data.filters?.file_status || undefined,
		original_file_type: data.filters?.file_type || undefined,
	}
	return axios.get(`/case/text_extract/${data.jobId}`, {
		params: { page_number: data.page_number, page_size: data.page_size, filter: filter },
	})
}

export const getBifrostJobDetailsApi = (data) => {
	const filter = {
		"jobs.file_status": data.filters?.file_status || undefined,
		original_file_type: data.filters?.file_type || undefined,
	}
	return axios.get(`/case/bifrost_job/${data.jobId}`, {
		params: { page_number: data.page_number, page_size: data.page_size, filter: filter },
	})
}

export const getFileFieldValues = async (job_id, case_id, field = "jobs.file_status") => {
	const statusList = await axios.get(`/case/bfile_field_values/${case_id}`, {
		params: { job_id, field },
	})
	return statusList
}

export const getUploadJobDetails = (data) => {
	const filter = {
		"jobs.file_status": data.filters?.file_status || undefined,
		original_file_type: data.filters?.file_type || undefined,
	}

	return axios.get(`/case/upload/${data.jobId}`, {
		params: {
			page_number: data.page_number,
			page_size: data.page_size,
			filter,
		},
	})
}

export const getKbMakingJobDetails = (data) => {
	return axios.get(`/case/kbmaking/${data}`)
}

export const getPIIExtractJobDetails = (data) => {
	const filter = {
		"jobs.file_status": data.filters?.file_status || undefined,
		original_file_type: data.filters?.file_type || undefined,
	}
	return axios.get(`/case/pii_extract/${data.jobId}`, {
		params: { page_number: data.page_number, page_size: data.page_size, filter: filter },
	})
}

export const bifrostJobService = (data) => {
	return axios.post("/case/bifrost_job", data)
}
